import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { Button, Modal, Popover } from "antd";
import { Link, useParams } from "react-router-dom";
import { TableDefaultPage } from "../../components/default/defaultPage";
import { TextShimmer } from "../../components/shimmer/shimmer";
import { Fileurl } from "../../config/url";
import DefaultCree8Img from "../../assets/images/Default/defaulCree8.png";
import moment from "moment";
import { toast } from "react-toastify";
import { ChangeWorkerStatusTerminate, GetWorkersType } from "../../helper/worksite/worksite";
import ConfirmedWorkerDefaultImg from "../../assets/svg/confirmedWorkerDefaultImg";
import TransferModal from "./transferModal";
import { ButtonSpinner } from "../../components/spinners";

const ConfirmedTable = ({ work_status, selectedTab,setWorkerType }) => {
  let { id } = useParams();
  let deafaulPage = {
    disclaimer: "No worker has been Confirmed the work",
    redirect: "",
    svg: <ConfirmedWorkerDefaultImg />,
    tab: true
  };
  const initialValues = {
    data: [],
    isStatusLoading: false,
    extra: {},
    type: work_status,
    date: null,
    search: "",
    isLoadingId: "",
    isLoading: false,
    isFetchLoader: false,
    isShimmer: true,
    id: id
  };
  const [worksite, setWorksite] = useState(initialValues);
  const [selectedItem, setSelectedItem] = useState()
  const [openTransferModal, setOpenTransferModal] = useState(false)
  const [openTerminateModal, setOpenTerminateModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const handleWorksite = {
    getWorkers: async (work_status) => {
      let data = await GetWorkersType(worksite);
      if (data?.status) {
        setWorksite({
          ...worksite,
          data: data?.data?.data,
          extra: data?.extra,
          worker_status: work_status,
          isShimmer: false,
          cursor: "",
        });
        return data;
      } else {
        setWorksite({
          ...worksite,
          isShimmer: false,
        });
        return data;
      }
    }
  }
  const saveChanges = async () => {
    setIsLoading(true)
    let data = await ChangeWorkerStatusTerminate(selectedItem, worksite)
    if (data?.status) {
      toast.success(data?.message)
      setOpenTerminateModal(false)
      const param = { type: work_status, id: id?.id }
      const res = await GetWorkersType(param)
      if (res?.status) {
        setWorksite({
          ...worksite,
          data: res?.data?.data,
        })
      }
    }
  }
  const transferWorker = async () => {
    setOpenTransferModal(true)
  }
  const terminateWorker = async () => {
    setOpenTerminateModal(true)
  }
  useEffect(() => {
    if (selectedTab == '4') {
      setWorkerType('Confirmed')
      handleWorksite?.getWorkers(work_status)
    }
  }, [selectedTab])
  const content = (
    <div>
      {/* <p className="px-4 py-2 cursor-pointer border-b-2" onClick={transferWorker}>Transfer</p> */}
      <p className="px-4 py-2 cursor-pointer">Sign off Shift</p>
    </div>
  );
  const onCloseTransefer = () => {
    setOpenTransferModal(false)
  }
  const onClose = () => {
    setOpenTerminateModal(false)
  }
  return (
    <>
      {worksite?.isShimmer ?
        <div className="py-6 px-4 ">
          <TextShimmer data={{ gap: 15, line: 20 }} />
        </div>
        :
        worksite?.data?.length > 0 ?
          <div className="relative">
            {/* <div className="absolute top-[-65px] w-1/2 right-0 flex justify-end items-center gap-4">
        <Select defaultValue="Mass Options" className="border-black">
          <Select.Option value="Mass Options">Mass Options</Select.Option>
        </Select>
        <Button className="flex justify-center items-center p-1 pl-3 border border-[#d4d3d3]">
          Roaster Worker{" "}
          <div className="bg-orange-500 p-1 rounded-md text-white ml-3">
            <FaPlus />
          </div>
        </Button>
      </div> */}
            <table className="w-full">
              <thead className="bg-[#E8F3FF] text-center">
                <tr className="text-left">
                  <th className=" px-4 py-3 ">
                    <div className="flex items-center justify-start">Worker Name</div>
                  </th>
                  <th className=" px-4 py-3 ">
                    <div className="flex items-center justify-center"></div>
                  </th>
                  <th className=" px-4 py-3 ">
                    <div className="flex items-center justify-center">Action</div>
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {worksite?.data?.length > 0 && worksite?.data?.map((item, index) => (
                  <tr key={index} className="border-b border-[#F0F0F0]">
                    <td className="px-4 py-3">
                      <div className="flex items-center justify-start">
                        <div className="relative text-center mr-[10px]">
                          <img
                            src={item?.users_profile_details?.data
                              ? Fileurl + item?.users_profile_details?.data
                              : DefaultCree8Img}
                            alt=""
                            className="w-[80px] h-[80px] rounded mx-auto"
                          />
                          <span className="text-[11px] text-[#41C700] bg-[#D9F4CC] border border-[#41C700] px-[6px] py-[2px] relative top-[-15px]">
                            confirmed
                          </span>
                        </div>
                        <div>
                          <p className="font-bold text-xl">{item?.users.length>0?item.users[0].name:'-'}</p>
                          <p className="text-sm text-[#707070]">
                            Work:{" "}
                            {/* {item.work.map((item, index) => (
                        <span key={index} className="text-[#0F4C7D]">
                          {item}
                        </span>
                      ))} */}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center justify-center">
                        <div className="text-center mx-5">
                          <p className="text-lg">Started</p>
                          <p className="text-lg text-[#A1A1A1]">{item?.started}</p>
                        </div>
                        <div className="text-center mx-5">
                          <p className="text-lg">Finished</p>
                          <p className="text-lg text-[#A1A1A1]">{item?.finished}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <Popover placement="left" content={content} trigger="click">
                        <FaPlus className="text-sm border-2 p-1 border-black w-[25px] h-[25px] flex justify-center items-center rounded-full cursor-pointer marginAuto" onClick={() => setSelectedItem(item)} />
                      </Popover>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          :
          <TableDefaultPage data={deafaulPage} />}
      <TransferModal isOpen={openTransferModal} onClose={onCloseTransefer} worksite={worksite} setWorksite={setWorksite} selectedItem={selectedItem} />
      <Modal title="Are You Sure To Terminate This Worker" className="clockin-modal" open={openTerminateModal} onCancel={onClose} footer={[
        <Button key="save" onClick={saveChanges} className="btn btn-blue bg-blue-disable">
          {isLoading ? <ButtonSpinner /> : 'Terminate'}
        </Button>]}>
        <p className="mt-7">Name : <span className='text-[#A1A1A1] ml-8'>Smith Work</span></p>
      </Modal>
    </>
  );
};

export default ConfirmedTable;
